<template>
  <div class="chart-container">
    <canvas ref="canvas" class="canvas-graph"></canvas>
  </div>
</template>

<script>
import { Bar } from "vue-chartjs";

Chart.defaults.global.legend.display = false;
Chart.defaults.global.defaultFontColor = "#ededed";
Chart.defaults.global.defaultFontSize = 8;

import ChartSettings from "./chart.settings.js";

import ChartDataLabels from "chartjs-plugin-datalabels";

import moment from "moment";

export default {
  extends: Bar,
  data() {
    return {
      labels: [],
      primary_data: []
    };
  },
  props: {
    dataset: Array,
    color: {
      type: String,
      default: "#CBD9E6"
    },
    range: Object
  },
  watch: {
    dataset() {
      this.rerender();
    }
  },
  methods: {
    buildDataset() {
      if (this.dataset.length <= 14) {
        this.labels = this.dataset.map(d =>
          moment(d.timestamp, "DD.MM.YYYY").format("ddd")
        );
      } else {
        this.labels = this.dataset.map(d => d.timestamp);
      }

      this.primary_data = this.dataset.map(d => d.income);
    },
    rerender() {
      this.buildDataset();
      this.renderChart(
        {
          labels: this.labels,
          datasets: [
            {
              data: this.primary_data,
              backgroundColor: this.color
            }
          ]
        },
        {
          scales: ChartSettings.scales
        }
      );
    }
  },
  mounted() {
    this.addPlugin(ChartDataLabels);
    this.rerender();
  }
};
</script>

<style scoped>
.canvas-graph {
  background: #1d1d1b;
  padding-top: 5vh;
  width: 75vh !important;
  height: 50vh !important;
  border-radius: 0 0 1vh 1vh;
}

.chart-container {
  width: min-content;

  display: block;
}
</style>